import React from "react";
import "./footer.css";
import {Link} from "react-router-dom";

// images
import facebookLogo from "../../images/facebook.svg";
import twitter from "../../images/twitter.svg";
import instagram from "../../images/instagram.svg";
import discord from "../../images/discord.svg";
import opensea from "../../images/opensea.svg";
import rarity from "../../images/rarity.png";


const Footer = () => {
    return (
        <div className="footer">
            <div className="foot">
                {/* <div className="footer-navigation">
                    <p>
                        Game of shangus: <Link to="/">About Us</Link>
                    </p>
                    <p>
                        Support: <Link to="/">Feedback</Link>
                    </p>
                </div> */}
                <div className="social-media-icons"> 
                {/* <img src={facebookLogo} alt="facebook" /> */}
                <a 
                    href="https://www.twitter.com/Legendsofshangu"
                    target="_blank"
                    
                    >

                        <img src={twitter} alt='twitter' />
                    </a>
                    <a href="https://instagram.com/Legendsofshangu" target="_blank">
                        <img src={instagram} alt='instagram' />
                    </a>
                    <a href="https://discord.gg/legendsofshangu" target="_blank"> 
                        <img src={discord} alt='discord' />
                    </a>
                    <a href="https://raritysniper.com/" target="_blank">
                        <img src={rarity} alt='rarity'/>
                    </a>
                    <a href="https://opensea.io/collection/losbydavidhuynh" target="_blank">
                        <img src={opensea} alt='opensea' />
                    </a>
                </div>

                <div className="footer-bottom-2">
              <p>All rights reserved.</p>
              <p>Privacy Policy</p>
              <p>Terms of use</p>
            </div>
            </div>
            {/* <hr className="strike-line"/> */}
            {/* <div className="footer-bottom-1">
              <p>+11 111 111 11111</p>
              <p>email@gmail.com</p>

            </div> */}
            
        </div>
    );
};

export default Footer;
